// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R4B1b1 {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
  min-width: 0;
  padding: var(--spacing-3) 0;
}

.WckB4c {
  position: relative;
}

.Cp4r71 {
  position: absolute;
  top: -11px;
  right: -3px;
  width: 110px;
  height: 56px;
  pointer-events: none;
}

.YylthG {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-title-lg-font-size);
  font-weight: var(--type-title-lg-font-weight);
  line-height: var(--type-title-lg-line-height);
  color: var(--text-neutral-dark);
}

.wlqZYz {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-3);
  width: 100%;
  min-height: 373px;
  padding: var(--spacing-3) var(--spacing-3);
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  text-align: center;
}

.f_Z6QO {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--surface-primary-subtle);
}

.cOq4L7 {
  width: 16px;
  height: 16px;
}

.jpyLIV {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1);
  width: 270px;
  max-width: 100%;
  color: var(--text-neutral-dark);
}

.u9SPaE {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
}

.pZyS7o {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
}

.vhtX3v {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 373px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
}

.axXXc2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);
}

.ATJeJk {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
}

._3Qsf8 button {
  gap: var(--spacing-0-5);
}

._3Qsf8 button img {
  width: 12px;
  height: 12px;
  filter: brightness(0) invert(1);
}

.LLn45Z {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.tBXiQk {
  width: 100%;
  height: 1px;
  background-color: var(--stroke-neutral-subtle);
}

.wi_fsr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 373px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
}

.Nf7uMT {
  display: grid;
  grid-template-columns: 733fr 355fr;
  gap: var(--spacing-3);
  width: 100%;
  align-items: stretch;
}

.hNqHHG {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 343px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
}

.BagXvj {
  display: flex;
  align-items: center;
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);
}

.hv8Fyt {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.YEJdjJ {
  width: 100%;
  height: 1px;
  background-color: var(--stroke-neutral-subtle);
}

.ym4a5g {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-3);
  padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3) var(--spacing-3);
  text-align: center;
}

.MGtrTY {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--surface-primary-subtle);
}

.DOaNB5 {
  width: 16px;
  height: 16px;
}

.dzBsJI {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1);
  color: var(--text-neutral-dark);
}

.DZeA2P {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
}

.bo5K6k {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
}

._lvWTq {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: var(--spacing-1-5);
  align-content: flex-start;
}

.hYBwsX {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 111px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
}

.SsbaOc {
  display: block;
  padding: 0;
  border: none;
  background: none;
  text-align: inherit;
  cursor: pointer;
}

.SsbaOc:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 2px;
  border-radius: var(--radius-s);
}

.njY0E3 {
  width: 16px;
  height: 16px;
}

.QxPC8v {
  display: block;
  width: 100%;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  overflow-wrap: break-word;
}

@media (max-width: 1023px) {
  .Nf7uMT {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .R4B1b1 {
    gap: var(--spacing-2);
    padding: var(--spacing-2) 0;
  }

  .axXXc2 {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-1-5);
  }

  .Nf7uMT {
    gap: var(--spacing-2);
  }

  ._lvWTq {
    grid-template-columns: 1fr;
    gap: var(--spacing-1-5);
  }

  .hYBwsX {
    flex: 1 1 auto;
    width: 100%;
  }
}

.Be7Jet {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-3);
}

.Tbxw2t {
  padding: 4px 0 0;
}

.Tbxw2t .YylthG {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.Tbxw2t .Be7Jet {
  padding-right: 24px;
}

.Tbxw2t .LLn45Z {
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
}

.Tbxw2t .axXXc2 button {
  height: 32px;
  min-height: 32px;
  font-size: 14px;
  --size: 14px;
}

.Tbxw2t .axXXc2 [data-testid='buttonHomePageEmissorSeeAll'] {
  width: 57px;
  height: 24px;
  min-height: 24px;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Source Sans 3', Arial, sans-serif;
  white-space: nowrap;
}

.Tbxw2t .axXXc2 [data-testid='buttonHomePageEmissorSeeAll'] span {
  font-family: 'Source Sans 3', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
}

.Tbxw2t .axXXc2 [data-testid='HomePageEmissorNewRecharge'] {
  width: 100px;
  padding: 8px;
  white-space: nowrap;
  font-size: 12px;
  --size: 12px;
}

.Tbxw2t .axXXc2 [data-testid='HomePageEmissorNewRecharge'] img {
  width: 12px;
  height: 12px;
}

.r2W4MK {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 128px;
  height: 56px;
  margin: -12px -14px;
}

.Tbxw2t[data-migration-tour-step='0'] [data-benefits-onboarding-anchor='emissor-orders'],
.Tbxw2t[data-migration-tour-step='2'] [data-benefits-onboarding-anchor='emissor-new-recharge'],
.Tbxw2t[data-migration-tour-step='5'] [data-benefits-onboarding-anchor='emissor-tracking'],
.Tbxw2t[data-migration-tour-step='6'] [data-benefits-onboarding-anchor='emissor-contracted-benefits'],
.Tbxw2t[data-migration-tour-step='7'] [data-benefits-onboarding-anchor='emissor-employees'] {
  transform: translateY(-8.515625px);
}

.Tbxw2t[data-migration-tour-step='3'] [data-benefits-onboarding-anchor='emissor-credit-date'],
.Tbxw2t[data-migration-tour-step='4'] [data-benefits-onboarding-anchor='emissor-order-actions'] {
  transform: translateY(-8.515625px);
}

.Tbxw2t[data-migration-tour-step='4'] [data-benefits-onboarding-anchor='emissor-order-actions'] {
  width: 24px;
  transform: translate(-4.21875px, -8.015625px);
}

.Tbxw2t[data-migration-tour-step='3'] [data-benefits-onboarding-anchor='emissor-credit-date'] {
  transform: translate(0.296875px, -8.015625px);
}

.Tbxw2t ._lvWTq {
  gap: 12px;
}

.Tbxw2t [data-testid='viewHomePageEmissorTrackingEmpty'] > div:last-child {
  max-width: 270px;
}

.c6_G45 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ss_7OX {
  height: 373px;
}
.WVKHrL {
  height: 343px;
}
.c6_G45 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left top;
}
.BO6ZPJ {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: flex-start;
}
.BO6ZPJ > div {
  width: 111px;
  height: 111px;
}

.Tbxw2t:not([data-migration-tour-step]) .wlqZYz {
  min-height: 353.740295px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HomePageEmissor/HomePageEmissor.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,8CAA8C;EAC9C,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,qBAAqB;EACrB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;;EAKE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n  min-width: 0;\n  padding: var(--spacing-3) 0;\n}\n\n.migrationModelSwitch {\n  position: relative;\n}\n\n.migrationModelSwitchHighlight {\n  position: absolute;\n  top: -11px;\n  right: -3px;\n  width: 110px;\n  height: 56px;\n  pointer-events: none;\n}\n\n.pageTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-lg-font-size);\n  font-weight: var(--type-title-lg-font-weight);\n  line-height: var(--type-title-lg-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-3);\n  width: 100%;\n  min-height: 373px;\n  padding: var(--spacing-3) var(--spacing-3);\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  text-align: center;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--surface-primary-subtle);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n.textBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1);\n  width: 270px;\n  max-width: 100%;\n  color: var(--text-neutral-dark);\n}\n\n.title {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n}\n\n.body {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n}\n\n.ordersCard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 373px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n}\n\n.ordersHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);\n}\n\n.ordersHeaderLeft {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-3);\n}\n\n.newRechargeButton button {\n  gap: var(--spacing-0-5);\n}\n\n.newRechargeButton button img {\n  width: 12px;\n  height: 12px;\n  filter: brightness(0) invert(1);\n}\n\n.ordersTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.ordersDivider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle);\n}\n\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 373px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n}\n\n.placeholderGrid {\n  display: grid;\n  grid-template-columns: 733fr 355fr;\n  gap: var(--spacing-3);\n  width: 100%;\n  align-items: stretch;\n}\n\n.rastreioCard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 343px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n}\n\n.rastreioHeader {\n  display: flex;\n  align-items: center;\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);\n}\n\n.rastreioTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.rastreioDivider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle);\n}\n\n.rastreioBody {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: var(--spacing-3);\n  padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3) var(--spacing-3);\n  text-align: center;\n}\n\n.bigIconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--surface-primary-subtle);\n}\n\n.bigIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.rastreioEmptyText {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1);\n  color: var(--text-neutral-dark);\n}\n\n.rastreioEmptyTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n}\n\n.rastreioEmptyBody {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n}\n\n.quickActionsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: var(--spacing-1-5);\n  align-content: flex-start;\n}\n\n.quickActionCard {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  height: 111px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n}\n\n.quickActionButton {\n  display: block;\n  padding: 0;\n  border: none;\n  background: none;\n  text-align: inherit;\n  cursor: pointer;\n}\n\n.quickActionButton:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 2px;\n  border-radius: var(--radius-s);\n}\n\n.quickActionIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.quickActionLabel {\n  display: block;\n  width: 100%;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  overflow-wrap: break-word;\n}\n\n@media (max-width: 1023px) {\n  .placeholderGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    gap: var(--spacing-2);\n    padding: var(--spacing-2) 0;\n  }\n\n  .ordersHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-1-5);\n  }\n\n  .placeholderGrid {\n    gap: var(--spacing-2);\n  }\n\n  .quickActionsRow {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-1-5);\n  }\n\n  .quickActionCard {\n    flex: 1 1 auto;\n    width: 100%;\n  }\n}\n\n.heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-3);\n}\n\n.migrationContainer {\n  padding: 4px 0 0;\n}\n\n.migrationContainer .pageTitle {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.migrationContainer .heading {\n  padding-right: 24px;\n}\n\n.migrationContainer .ordersTitle {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 23px;\n}\n\n.migrationContainer .ordersHeader button {\n  height: 32px;\n  min-height: 32px;\n  font-size: 14px;\n  --size: 14px;\n}\n\n.migrationContainer .ordersHeader [data-testid='buttonHomePageEmissorSeeAll'] {\n  width: 57px;\n  height: 24px;\n  min-height: 24px;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: 'Source Sans 3', Arial, sans-serif;\n  white-space: nowrap;\n}\n\n.migrationContainer .ordersHeader [data-testid='buttonHomePageEmissorSeeAll'] span {\n  font-family: 'Source Sans 3', Arial, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.migrationContainer .ordersHeader [data-testid='HomePageEmissorNewRecharge'] {\n  width: 100px;\n  padding: 8px;\n  white-space: nowrap;\n  font-size: 12px;\n  --size: 12px;\n}\n\n.migrationContainer .ordersHeader [data-testid='HomePageEmissorNewRecharge'] img {\n  width: 12px;\n  height: 12px;\n}\n\n.migrationRechargeTarget {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 128px;\n  height: 56px;\n  margin: -12px -14px;\n}\n\n.migrationContainer[data-migration-tour-step='0'] [data-benefits-onboarding-anchor='emissor-orders'],\n.migrationContainer[data-migration-tour-step='2'] [data-benefits-onboarding-anchor='emissor-new-recharge'],\n.migrationContainer[data-migration-tour-step='5'] [data-benefits-onboarding-anchor='emissor-tracking'],\n.migrationContainer[data-migration-tour-step='6'] [data-benefits-onboarding-anchor='emissor-contracted-benefits'],\n.migrationContainer[data-migration-tour-step='7'] [data-benefits-onboarding-anchor='emissor-employees'] {\n  transform: translateY(-8.515625px);\n}\n\n.migrationContainer[data-migration-tour-step='3'] [data-benefits-onboarding-anchor='emissor-credit-date'],\n.migrationContainer[data-migration-tour-step='4'] [data-benefits-onboarding-anchor='emissor-order-actions'] {\n  transform: translateY(-8.515625px);\n}\n\n.migrationContainer[data-migration-tour-step='4'] [data-benefits-onboarding-anchor='emissor-order-actions'] {\n  width: 24px;\n  transform: translate(-4.21875px, -8.015625px);\n}\n\n.migrationContainer[data-migration-tour-step='3'] [data-benefits-onboarding-anchor='emissor-credit-date'] {\n  transform: translate(0.296875px, -8.015625px);\n}\n\n.migrationContainer .quickActionsRow {\n  gap: 12px;\n}\n\n.migrationContainer [data-testid='viewHomePageEmissorTrackingEmpty'] > div:last-child {\n  max-width: 270px;\n}\n\n.migrationSkeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.migrationOrdersSkeleton {\n  height: 373px;\n}\n.migrationTrackingSkeleton {\n  height: 343px;\n}\n.migrationSkeleton img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: left top;\n}\n.migrationSkeletonShortcuts {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  align-items: flex-start;\n}\n.migrationSkeletonShortcuts > div {\n  width: 111px;\n  height: 111px;\n}\n\n.migrationContainer:not([data-migration-tour-step]) .card {\n  min-height: 353.740295px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `R4B1b1`,
	"migrationModelSwitch": `WckB4c`,
	"migrationModelSwitchHighlight": `Cp4r71`,
	"pageTitle": `YylthG`,
	"card": `wlqZYz`,
	"iconContainer": `f_Z6QO`,
	"icon": `cOq4L7`,
	"textBlock": `jpyLIV`,
	"title": `u9SPaE`,
	"body": `pZyS7o`,
	"ordersCard": `vhtX3v`,
	"ordersHeader": `axXXc2`,
	"ordersHeaderLeft": `ATJeJk`,
	"newRechargeButton": `_3Qsf8`,
	"ordersTitle": `LLn45Z`,
	"ordersDivider": `tBXiQk`,
	"loadingContainer": `wi_fsr`,
	"placeholderGrid": `Nf7uMT`,
	"rastreioCard": `hNqHHG`,
	"rastreioHeader": `BagXvj`,
	"rastreioTitle": `hv8Fyt`,
	"rastreioDivider": `YEJdjJ`,
	"rastreioBody": `ym4a5g`,
	"bigIconWrapper": `MGtrTY`,
	"bigIcon": `DOaNB5`,
	"rastreioEmptyText": `dzBsJI`,
	"rastreioEmptyTitle": `DZeA2P`,
	"rastreioEmptyBody": `bo5K6k`,
	"quickActionsRow": `_lvWTq`,
	"quickActionCard": `hYBwsX`,
	"quickActionButton": `SsbaOc`,
	"quickActionIcon": `njY0E3`,
	"quickActionLabel": `QxPC8v`,
	"heading": `Be7Jet`,
	"migrationContainer": `Tbxw2t`,
	"migrationRechargeTarget": `r2W4MK`,
	"migrationSkeleton": `c6_G45`,
	"migrationOrdersSkeleton": `ss_7OX`,
	"migrationTrackingSkeleton": `WVKHrL`,
	"migrationSkeletonShortcuts": `BO6ZPJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
